// JavaScript Document

global.popupImagePicker = function(field, returnId, albumId) {
    field = $(field)
    if (!field.is('input')) {
        field = $(field).prev('input');
    }
    // $(field).val()
    $.window({
        id: 'imageBrowserWindow',
        title: 'Choisir une image',
        url: 'admin/galeries/selector/'+((field.val())?field.val():'')+'/'+((albumId)?'?album_id='+albumId:''),
        method: 'ajax',
        maxWidth: -1,		  // the minimum width, if -1 means no checking
        maxHeight: -1,		 // the minimum height, if -1 means no checking
        showFooter: false,
        maximizable: true,
        closable: true,
        showModal: false,
        width: '98%',
        height: '98%',
        checkBoundary: true,
        withinBrowserWindow: false,
        onIframeEnd: function() {
            //initBlock(this.windowId);
        },
        variables: {
            'field': field,
            'onSelection': function(file) {
                var field = $(this.field);
                var fieldPreview = field.next().find('.input__preview');
                var fieldName = field.next().find('.input__label');
                var fieldRemove = field.next().find('.input__remove');
                if (returnId) {
                    field.val(file.id).change();
                }
                else {
                    field.val(file.img).change();
                };
                /*
                if (fieldPreview[0].tagName == 'svg') {

                    fieldPreview.replaceWith(iconImg()'<img src="" class="input__preview" />');
                    var fieldPreview = field.next().find('.input__preview');
                }
                */
                fieldPreview.replaceWith(iconImg(file.thumb, 'input__preview', null, 'auto'));

                //fieldPreview.attr('src', file.thumb);
                fieldName.html(file.nom);
                fieldRemove.show();
            }
        }
    });
}

global.popupIconPicker = function(field, returnId) {
    field = $(field)
    if (!field.is('input')) {
        field = $(field).prev('input');
    }
    var currentPath = $(field).val();
    
    $.window({
        id: 'imageBrowserWindow',
        title: 'Choisir un icône',
        url: 'admin/icons/',
        data: {
            'selected': currentPath
        },
        method: 'ajax',
        maxWidth: -1,		  // the minimum width, if -1 means no checking
        maxHeight: -1,		 // the minimum height, if -1 means no checking
        showFooter: false,
        maximizable: true,
        closable: true,
        showModal: false,
        width: '98%',
        height: '98%',
        checkBoundary: true,
        withinBrowserWindow: false,
        onIframeEnd: function() {
            //initBlock(this.windowId);
        },
        variables: {
            'field': field,
            'onSelection': function(file) {
                var field = $(this.field);
                var fieldPreview = field.next().find('.input__preview');
                var fieldName = field.next().find('.input-picker-name');
                var fieldRemove = field.next().find('.input-picker-remove');

                field.val(file.id).change();
                /*
                if (fieldPreview[0].tagName == 'svg') {

                    fieldPreview.replaceWith(iconImg()'<img src="" class="input__preview" />');
                    var fieldPreview = field.next().find('.input__preview');
                }
                */
                fieldPreview.replaceWith(iconImg(file.id, 'input__preview'));

                //fieldPreview.attr('src', file.thumb);
                fieldName.html(file.nom);
                fieldRemove.show();
            }
        }
    });
}

global.popupDocPicker = function(field, returnId, folderId) {
    field = $(field)
    if (!field.is('input')) {
        field = $(field).prev('input');
    }
    // $(field).val()
    $.window({
        id: 'dataBrowserWindow',
        title: 'Choisir un document',
        url: 'admin/documents/selector/'+((field.val())?field.val():'')+'/'+((folderId)?'?folder_id='+folderId:''),
        method: 'ajax',
        maxWidth: -1,		  // the minimum width, if -1 means no checking
        maxHeight: -1,		 // the minimum height, if -1 means no checking
        showFooter: false,
        maximizable: true,
        closable: true,
        showModal: false,
        width: '98%',
        height: '98%',
        checkBoundary: true,
        withinBrowserWindow: false,
        onIframeEnd: function() {
            //initBlock(this.windowId);
        },
        variables: {
            'field': field,
            'onSelection': function(file) {
                var field = $(this.field);
                var fieldPreview = field.next().find('.input__preview');
                var fieldName = field.next().find('.input__label');
                var fieldRemove = field.next().find('.input__remove');
                if (returnId) {
                    field.val(file.id).change();
                }
                else {
                    field.val(file.img).change();
                };
                /*
                if (fieldPreview[0].tagName == 'svg') {

                    fieldPreview.replaceWith(iconImg()'<img src="" class="input__preview" />');
                    var fieldPreview = field.next().find('.input__preview');
                }
                */
                fieldPreview.replaceWith(iconImg(file.thumb, 'input__preview', null, 'auto'));

                //fieldPreview.attr('src', file.thumb);
                fieldName.html(file.nom);
                fieldRemove.show();
            }
        }
    });
}

global.popupLinkProvider = function(field, returnId) {
    field = $(field)
    if (!field.is('input')) {
        field = $(field).prev('input');
    }
    $.window({
        id: 'LinkProviderBrowserWindow',
        title: 'Choisir un lien',
        url: 'admin/link/?val='+$(field).val()+'&output=text',
        method: 'ajax',
        maxWidth: -1,		  // the minimum width, if -1 means no checking
        maxHeight: -1,		 // the minimum height, if -1 means no checking
        showFooter: false,
        maximizable: true,
        closable: true,
        showModal: false,
        width: '98%',
        height: '98%',
        checkBoundary: true,
        withinBrowserWindow: false,
        onIframeEnd: function() {
            //initBlock(this.windowId);
        },
        variables: {
            'field': field,
            'onSelection': function(file) {
                var field = $(this.field);
                updateDataPicker(field, file.url, file.nom, file.img);
            }
        }
    });
}

global.popupLinkIncProvider = function(field, returnId) {
    field = $(field)
    if (!field.is('input')) {
        field = $(field).prev('input');
    }
    $.window({
        id: 'LinkProviderBrowserWindow',
        title: 'Choisir une source',
        url: 'admin/linkInc/?val='+$(field).val()+'&output=text',
        method: 'ajax',
        maxWidth: -1,		  // the minimum width, if -1 means no checking
        maxHeight: -1,		 // the minimum height, if -1 means no checking
        showFooter: false,
        maximizable: true,
        closable: true,
        showModal: false,
        width: '98%',
        height: '98%',
        checkBoundary: true,
        withinBrowserWindow: false,
        onIframeEnd: function() {
            //initBlock(this.windowId);
        },
        variables: {
            'field': field,
            'onSelection': function(file) {
                var field = $(this.field);
                updateDataPicker(field, file.url, file.nom, file.img);
            }
        }
    });
}

global.popupInputEditor = function(field) {
	$.window({
		id: 'imageBrowserWindow',
		title: 'Modifier le type du champ',
		url: 'inc.php?incUrl=modules/admin/public/window.inputeditor.php',
		method: 'ajax',
		maxWidth: -1,		  // the minimum width, if -1 means no checking
		maxHeight: -1,		 // the minimum height, if -1 means no checking
		showFooter: false,
		maximizable: false,
		closable: true,
		showModal: true,
		width: 850,
		height: 550,
		checkBoundary: true,
		withinBrowserWindow: false,
		onIframeEnd: function() {
            //initBlock(this.windowId);
        },
		variables: {
			'field': field,
			'value': $(field).val(),
			'onSubmit': function(code) {
				$(this.field).val(code).change();
				setTimeout(function() {$(this.field).change();}, 100);
			}
		}
	});
}

global.popupCropperData = function(slug, items, request, extraData, callback, ratio) {
    var data = [];
    $.each(items, function( index, value ) {
        data.push({
            "slug": slug,
            "id": value.id,
            "width": value.data.data.width,
            "height": value.data.data.height,
            "file": value.data.data.src,
            "ratio": (ratio)?value.data.data[ratio]:null
        });
    });
    popupCropper(data, request, extraData, callback)
}



global.popupCropper = function(items, request, extraData, callback, index, data) {
    if (!data) data = [];
    if (!index) index = 0;
    var currentWindow = $.window({
        id: 'imageBrowserWindow',
        title: 'Recadrage des images ('+(index+1)+' de '+items.length+')',
        content: '<div id="popup-jcrop" class="popup-jcrop" style="display: none;">' +
        '<div class="popup__body"><div class="js-img"><canvas id="viewport-cropper" src="'+items[index].file+'" width="'+items[index].width+'" height="'+items[index].height+'"></canvas></div></div>' +
        '<div style="margin: 0 0 5px; text-align: center;">' +
        '<div class="toolbar--form window__toolbar--bottom">' +
        '<button class="btn btn-auto">'+icon('tool-wand')+__('Auto')+'</button> ' +
        '<button class="btn-cancel btn-type-caution btn btn--danger">'+icon('shape-cross')+__('Annuler')+'</button> ' +
        '<button class="btn btn--success btn--submit js-upload btn_browse btn_browse_small">'+icon('status-ok')+__('Valider')+'</button>' +
        '</div>' +
        '</div>' +
        '</div>',
        /*content: '<div id="popup-jcrop" class="popup-jcrop" style="display: none;">' +
        '<div class="popup__body"><div class="js-img">'+
        '<div style="line-height: 0;"><canvas id="viewport" src="'+items[index].file+'" width="'+items[index].width+'" height="'+items[index].height+'"></canvas></div>' +
        '</div></div>' +
        '<div style="margin: 0 0 5px; text-align: center;">' +
        '<div class="toolbar--form window__toolbar--bottom">' +
        '<button class="btn-cancel btn-type-caution btn btn--danger">Annuler</button> ' +
        '<button class="btn btn--success btn--submit js-upload btn_browse btn_browse_small">Valider</button>' +
        '</div>' +
        '</div>' +
        '</div>',*/
        maxWidth: -1,		  // the minimum width, if -1 means no checking
        maxHeight: -1,		 // the minimum height, if -1 means no checking
        showFooter: false,
        maximizable: false,
        closable: true,
        showModal: true,
        width: '98%',
        height: '98%',
        checkBoundary: true,
        withinBrowserWindow: false,
        onShow: function () {
            var currentFrame = $('body');
            $(currentFrame).on('click', '.js-upload', function () {
                currentWindow.close();
                if (index < items.length - 1) {
                    popupCropper(items, request, extraData, callback, index+1, data);
                }
                else {
                    ajaxForm({
                        url: request,
                        method: 'POST',
                        data: data,
                        callback: function(data, form) {
                            if (callback) {
                                callback();
                            }
                        }
                    });
                }
            });
            $(currentFrame).on('click', '.btn-cancel', function () {
                if (index > 0) {
                    Swal.fire({
                            title: __('Annuler l\'envoi des images ?'),
                            text: __('Voulez-vous vraiment interompre l\'envoie des images ? Le découpage de toutes les images précédentes ne sera pas mémorisé et tous les transferts en cours seront annulé.'),
                            type: "warning",
                            showCancelButton: true,
                            confirmButtonColor: "#DD6B55",
                            confirmButtonText: __("Oui"),
                            cancelButtonText: __("Non")
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                currentWindow.close();
                                $(self.element).fileapi('clear');
                            } else {
                            }
                        });
                }
                else {
                    currentWindow.close();
                    $(self.element).fileapi('clear');
                }
            });

            var canvas = document.getElementById('viewport-cropper'),
                context = canvas.getContext('2d');
            var base_image = new Image();
            base_image.src = items[index].file;
            base_image.onload = function () {
                context.drawImage(base_image, 0, 0);
            }

            var jcrop_api;
            var cropKey = items[index].slug;
            $(currentFrame).find('.js-img').Jcrop({
                boxWidth: $(currentFrame).width(),
                boxHeight: $(currentFrame).height(),
                file: items[index].file,
                aspectRatio: items[index].ratio,
                selection: '100%',
                trueSize: [items[index].width, items[index].height],
                onSelect: function (coords) {
                    var currentData = {"id":items[index].id, "force":true};
                    if (extraData) {
                        mergeToObject(extraData, currentData);
                    }

                    if (!data[index]) data[index] = currentData;
                    if (!data[index].crop) data[index].crop = {};
                    data[index].crop[cropKey] = {};
                    for (const key in coords) {
                        if (key == 'id') {
                            data[index][key] = coords[key];
                        }
                        else if (coords.hasOwnProperty(key)) {
                            data[index].crop[cropKey][key] = coords[key];
                        }
                    }
                }
            },function(){
                jcrop_api = this;
            });



            $(currentFrame).on('click', '.btn-auto', function () {
                jcrop_api.animateTo([ jcrop_api.getBounds()[0], jcrop_api.getBounds()[1] ]);
                return false;
            });
        }
    });
}

global.adtPopup = function(url, title, icon, width, height) {
    $.window({
        id: 'adtWindow',
        title: title,
        url: url,
        icon: icon,
        method: 'ajax',
        maxWidth: -1,		  // the minimum width, if -1 means no checking
        maxHeight: -1,		 // the minimum height, if -1 means no checking
        showFooter: false,
        maximizable: false,
        closable: true,
        showModal: true,
        width: (width)?width:1000,
        height: (height)?height:650,
        checkBoundary: true,
        withinBrowserWindow: false,
        onIframeEnd: function() {},
        onClose: function() {
            if (typeof Turbolinks !== 'undefined') {
                var currentScroll = $(window).scrollTop();
                Turbolinks.visit(location.toString());
                setTimeout(function(){ $(window).scrollTop(currentScroll) }, 250);
                setTimeout(function(){ $(window).scrollTop(currentScroll) }, 500);
                setTimeout(function(){ $(window).scrollTop(currentScroll) }, 1000);
            }
            else {
                location.reload();
            }
        }
    });
}

global.updateDataPicker = function(field, value, label, img) {
    var fieldName = $(field.attr('name'))
    var fieldPreview = field.next().find('.input__preview');
    var fieldPreviewMeta = field.next().find('.input-picker-meta-preview');
    var fieldNameMeta = field.next().find('.input-picker-meta-name');
    var fieldName = field.next().find('.input-picker-name');
    var fieldRemove = field.next().find('.input-picker-remove');

    field.val(value).change();
    fieldPreview.attr('src', img);
    fieldName.html(label);
    fieldPreviewMeta.val(img).change();
    fieldNameMeta.val(label).change();
    fieldRemove.show();
}

window.popupSocialiteLoginOnFinish = null;
global.popupFbLogin = function(callback) {
    window.popupSocialiteLoginOnFinish = callback;
    var currentWindow = $.window({
        id: 'fbWindow',
        title: 'Identification requise',
        icon: 'secure-key',
        url: 'api/users/login/?output=text&form=1',
        method: 'ajax',
        maxWidth: -1,		  // the minimum width, if -1 means no checking
        maxHeight: -1,		 // the minimum height, if -1 means no checking
        showFooter: false,
        maximizable: false,
        minimizable: false,
        closable: true,
        showModal: true,
        width: '600',
        height: '705',
        checkBoundary: true,
        withinBrowserWindow: false
    });
}

global.socialiteLogin = function(partner) {
    $('.login-avatar').animate({'opacity':0.25});
    if (typeof popupSocialiteLoginOnFinish !== 'undefined' && popupSocialiteLoginOnFinish) {
        var myWindow = window.open("users/auth/"+partner+"/");

        myWindow.addEventListener('unload', function(event) {
            console.log(myWindow.location.href);
        });
        var intervalTest = setInterval(function() {
            currentHref = myWindow.location.href;
            if (currentHref.indexOf($('base').attr('href')) !== -1) {
                myWindow.close();
                clearInterval(intervalTest);
                var data = {};
                if (currentHref.indexOf('code=') !== -1) data.redirect = 'users/register/';
                popupLoginProcess(data);
            }
        }, 250)

    }
    else {
        window.location.href = "users/auth/"+partner+"/";
    }
}